import React from 'react';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';

import './Footer.scss';

const Footer = () => {
  return (
    <div className="app__footer app__flex">
      <motion.div className='app__footer-info'>
        <div className="app__header-intro">
          <p className="head-text">
            Let’s get in <span>Touch</span>!
          </p>
          <p className="intro-text p-text">Hi! Thank you for your interest in contacting me.</p>
          <p className="intro-text p-text">Although I’m not currently looking for any new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I’ll try my best to get back to you!</p>
          <a href="mailto: seljanlucija@gmail.com" className="btn btn-orange">Say Hello</a>
        </div>

      </motion.div>
    </div>
  );
}

export default AppWrap(
  MotionWrap(Footer, 'app__contact'),
  'contact',
);
